import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './components/AuthProvider';
import { Layout } from './components/Layout';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { PasswordReset } from './pages/PasswordReset';
import { Workspace } from './pages/Workspace';
import { Gallery } from './pages/Gallery';
import { Profile } from './pages/Profile';
import { Billing } from './pages/Billing';
import { AdminDashboard } from './pages/admin/Dashboard';
import { AdminUsers } from './pages/admin/Users';
import { AdminModels } from './pages/admin/Models';
import { AdminScenarios } from './pages/admin/Scenarios';
import { AdminTiers } from './pages/admin/Tiers';
import { AdminAuditLog } from './pages/admin/AuditLog';

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/password-reset" element={<PasswordReset />} />
          <Route path="/password-reset/:token" element={<PasswordReset />} />

          {/* Protected routes */}
          <Route element={<Layout />}>
            <Route path="/workspace" element={<Workspace />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/billing" element={<Billing />} />

            {/* Admin routes */}
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/admin/models" element={<AdminModels />} />
            <Route path="/admin/scenarios" element={<AdminScenarios />} />
            <Route path="/admin/tiers" element={<AdminTiers />} />
            <Route path="/admin/audit-log" element={<AdminAuditLog />} />
          </Route>

          {/* Default redirect */}
          <Route path="*" element={<Navigate to="/workspace" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
